function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { __get, _get } from "nood-comp/src/net/xhr";
import { SessionManager } from "nood-comp/src/net/SessionManager";
export var AuthContext = /*#__PURE__*/React.createContext(null);
var minute = 1000 * 60;
function AuthProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  useEffect(function () {
    if (user === void 0) {
      SessionManager.validate({
        endpoint: "".concat(process.env.AUTH, "/admin/validate.php"),
        callback: function callback(isValid) {
          if (isValid) {
            _get('/adminuser', function (res) {
              var _res$http;
              if (((_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 401) {
                setUser(null); // this will show the AdminLoginPage.js
              } else {
                if (res.data) {
                  setUser(res.data);
                }
              }
            });
          } else setUser(null);
        }
      });
    }
  }, [user]);
  var invalidate = function invalidate(callback) {
    __get("/admin/invalidate.php", {
      base_url: process.env.AUTH
    }, function (res) {
      var _res$http2;
      if (((_res$http2 = res.http) === null || _res$http2 === void 0 ? void 0 : _res$http2.code) === 200) {
        setUser(null);
        callback === null || callback === void 0 || callback();
      }
    });
  };
  var refreshToken = function refreshToken() {
    // console.log(`refreshing..`);
    __get("/admin/validate.php", {
      base_url: process.env.AUTH
    }, function (res) {
      if (res.http.code !== 200) {
        invalidate();
      }
    });
  };
  useEffect(function () {
    refreshToken();
    setInterval(refreshToken, minute * 4);
  }, []);
  var value = {
    user: user,
    setUser: setUser,
    invalidate: invalidate
  };
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: value
  }, children);
}
export default AuthProvider;